import { RequestProfileContext } from '../RequestProfile.context'

function RequestProfileContextProvider({ children, ...restProps }) {
  return (
    <RequestProfileContext value={restProps}>{children}</RequestProfileContext>
  )
}

export default RequestProfileContextProvider
